// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d00K","questions":"styles_questions__1Blop","footer":"styles_footer__2XTtV"};